import { getPoisForConnectionMapping } from "@/helpers/poiHelper";
import POIStep from "@/components/POI/POIStep/POIStep.vue";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "Connections",
  props: ["editedItem", "step", "position", "regions", "isOwnedBySubPrincipal"],
  components: { POIStep },
  data: () => ({
    types: [
      "weather.com",
      "tripadvisor",
      "trustyou",
      "meaneo",
      "Planquadrat",
      "mapping-id",
      "Tramino-ID",
      "Tramino-ID-Tourismus",
      "Feratel-ID",
      "Feratel-CPS-ID",
      "OutdoorActive-ID",
      "Toubiz-ID",
      "Infomax-ID",
      "DetinationData-ID",
      "RCE-ID",
      "Travel-ID",
      "App-Kategorie",
      "Shoplink",
      "DestinationOne-ID"
    ],
    allPois: [],
    searchValue: "",
    searchValueRegions: "",
    regionPermission: []
  }),
  async mounted() {
    await this.getPermissionsDataForPoi();
  },
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    addItem() {
      this.editedItem.additionalData.push({});
    },
    removeItem(index) {
      this.editedItem.additionalData.splice(index, 1);
    },
    async getPermissionsDataForPoi() {
      try {
        await this.editedItem.regions?.asyncForEach(async region => {
          try {
            const headers = getTokenHeader();
            const response = await axios.get(
              `${env.poi_api_client_url}region/get_permission/${region}/${this.editedItem._id}`,
              {
                headers
              }
            );
            if (response.data)
              this.regionPermission.push({ ...response.data, region: region });
          } catch (e) {
            console.error(e);
          }
        });
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e.toString());
      }
    },
    getPermissionsForPoi(region) {
      const permission = this.regionPermission.find(
        r => r.region === region._id
      )?.permissions;
      switch (permission) {
        case "read":
          return "- Lesen";
        case "write":
          return "- Schreiben";
        case "admin":
          return "- Admin";
        case "status":
          return "- Statusbearbeitung";
        default:
          return "";
      }
    }
  },
  watch: {
    async searchValueRegions(val) {
      if (val?.length >= 3 || !val?.length) {
        await this.$store.dispatch("getRegions", {
          search: val,
          compact: true
        });
      }
    },
    async step(val) {
      // val muss mit Schritt in POIStepsWrapper.vue übereinstimmen
      if (val === 32 && !this.allPois?.length) {
        this.allPois = await getPoisForConnectionMapping(this.principal._id);
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    principal() {
      return this.$store.state.selectedPrincipal;
    },
    isRegion() {
      return (
        this.$store.state.currentUser?.principal_id === this.REGION_PRINCIPAL
      );
    }
  }
};
